/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ProfileResponse {
    getFixupPrototypeFunction() { return ProfileResponse.fixupPrototype; }

    static newInstance(model: Partial<ProfileResponse>): ProfileResponse {
        let obj = Object.assign(new ProfileResponse(), model);
        ProfileResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ProfileResponse>): ProfileResponse {
        if (!model) return null;
        return ProfileResponse.newInstance(<ProfileResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ProfileResponse) {
        if (!obj) return;

        models.ProfileResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ProfileResponse): boolean {
        Object.setPrototypeOf(obj, ProfileResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * user id
     */
    user_id: string;

    /**
     * source user id
     */
    source_user_id: string;

    /**
     * username
     */
    username: string;

    /**
     * status
     */
    status: string;

    /**
     * email
     */
    email: string;

    /**
     * first name
     */
    first_name: string;

    /**
     * last name
     */
    last_name: string;

    /**
     * timezone
     */
    timezone: string;

    /**
     * mobile number
     */
    mobile: string;

    /**
     * sso user id
     */
    sso_userid: string;

    /**
     * access_key
     */
    access_key: string;

    /**
     * valid date
     */
    valid_till: string;

    /**
     * last login time
     */
    last_login_time: string;

    /**
     * Preferred language of the user.
     */
    preferred_language: models.PreferredLanguage;

}
